"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
interface CollapsibleHeightProps {
  /** Full height of the content in px. If ≤ maxHeight, renders normally. */
  height: number;
  /** Collapsed max height in px. Default 600. */
  maxHeight?: number;
  /** Label shown in the expand button, e.g. "53 nodes". */
  expandLabel?: string;
  /** Render prop — receives the active height to use for the chart */
  children: (activeHeight: number) => React.ReactNode;
}

/**
 * Wraps chart content that may be taller than maxHeight.
 * Passes the active render height to children so the SVG itself is sized
 * correctly — avoids recharts SVG overflow: visible painting past the clip.
 */
export function CollapsibleHeight(t0) {
  const $ = _c(10);
  const {
    height,
    maxHeight: t1,
    expandLabel,
    children
  } = t0;
  const maxHeight = t1 === undefined ? 600 : t1;
  const [expanded, setExpanded] = useState(false);
  const isCollapsible = height > maxHeight;
  const activeHeight = !isCollapsible || expanded ? height : maxHeight;
  let t2;
  if ($[0] !== activeHeight || $[1] !== children) {
    t2 = children(activeHeight);
    $[0] = activeHeight;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== expandLabel || $[4] !== expanded || $[5] !== isCollapsible) {
    t3 = isCollapsible && <button type="button" onClick={() => setExpanded(_temp)} className="mt-1 flex w-full items-center justify-center gap-1 py-1 text-caption text-foreground-muted hover:text-foreground-secondary">{expanded ? <><FiChevronUp className="h-3 w-3" />Collapse</> : <><FiChevronDown className="h-3 w-3" />{expandLabel ? `Show all ${expandLabel}` : "Show more"}</>}</button>;
    $[3] = expandLabel;
    $[4] = expanded;
    $[5] = isCollapsible;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp(v) {
  return !v;
}